import React from 'react';
import { useQueryClient } from 'react-query';
import ConfigDropdown from './ConfigDropdown';
import { isAdvanceCustomerType } from '../alertConfig.utils';
import { Retry } from '@components/common';
import { BackBtn, HeaderWrapper, ConfigHeaderText } from '../styled';
import LeftChevronIcon from '@src/icons/common/chevron-left.svg';
import { useUpdateConfigList } from '@components/metrics-panel-hz/hooks/alerts/useUpdateConfigList';
import { CONFIG_LIST_KEY } from '@components/metrics-panel-hz/hooks/alerts/alertsQueryKey.constants';
import { useSelector } from 'react-redux';
import {
  aiAlertsAddCustomDimensionsSelector,
  aiAlertsConfigSelector,
} from '@store/common/selectors';
import { useHistory } from 'react-router-dom';

export default function ConfigHeader() {
  const { isLoading: isMutateLoading } = useUpdateConfigList();
  const queryClient = useQueryClient();
  const isConfigFeatureEnabled = useSelector(aiAlertsConfigSelector);
  const isCustomDimensionAdditionEnabled = useSelector(aiAlertsAddCustomDimensionsSelector);
  const { customerRootCauseType = null } = queryClient.getQueryData(CONFIG_LIST_KEY) ?? {
    customerRootCauseType: null,
  };
  const history = useHistory();
  const displayDropdown =
    isConfigFeatureEnabled &&
    isCustomDimensionAdditionEnabled &&
    isAdvanceCustomerType(customerRootCauseType);

  if (isMutateLoading) {
    return <Retry isLoading={isMutateLoading} />;
  }

  const handleConfigDisplay = () => {
    // remove query param "config=true", to hide the config popup
    history.push({
      search: '',
    });
  };

  return (
    <>
      <BackBtn onClick={handleConfigDisplay}>
        <LeftChevronIcon />
        Back to Alert list
      </BackBtn>
      <HeaderWrapper>
        <ConfigHeaderText>AI Combinations</ConfigHeaderText>
        {displayDropdown && <ConfigDropdown />}
      </HeaderWrapper>
    </>
  );
}
